import script from "./AwardsCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AwardsCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./AwardsCarousel.vue?vue&type=style&index=0&id=59ba0cba&lang=scss"

const __exports__ = script;

export default __exports__